import Chart from "react-apexcharts";
import type { ApexOptions } from "apexcharts";
import { sharedOptions } from "../sharedOptions";
import type { IDonutChart, IDonutChartInternalProps } from "./../../../../types/charts/chart/donut_chart";
import { deepObjectsMerge } from "./../../../../utils/deepObjectsMerge";
import styles from "./donut-chart.module.scss";

const emptyChartColors = '#EAECF0';

export const DonutChart = ({
  id,
  series,
  options,
  centerLabel,
  opacity = 'solid',
  ...internalProps
}: IDonutChart) => {
  const {
    colors,
    labels,
    seriesFromParent,
    seriesIndex: seriesIndexFromParent,
  } = (internalProps as IDonutChartInternalProps);

  const possibleSeries = (series || seriesFromParent?.[seriesIndexFromParent].data);
  const isEmptyState = possibleSeries?.every(item => item === 0) || possibleSeries?.length === 0;
  const chartColors = isEmptyState ? [emptyChartColors] : colors;

  const chartSeries = isEmptyState ? [1] : possibleSeries;

  const localOptions: ApexOptions = {
    stroke: {
      show: false,
    },
    labels: labels,
    dataLabels: {
      enabled: false
    },
    colors: chartColors,
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
      active: {
        filter: {
          type: 'none',
        },
      }
    },
    plotOptions: {
      pie: {
        donut: {
          size: "50%",
        }
      },
    },
    chart: {
      id: id,
    },
  };

  const mergedOptions = deepObjectsMerge(sharedOptions, localOptions, (options ?? {}));

  return (
    <div className={styles["donut-chart"]} data-donut-chart-opacity={opacity}>
      <Chart
        options={mergedOptions}
        series={chartSeries}
        type="donut"
      />

      {
        (seriesFromParent?.[seriesIndexFromParent].label || centerLabel) && <div className={styles["donut-chart__center-label"]}>
          {seriesFromParent?.[seriesIndexFromParent].label || centerLabel}
        </div>
      }
    </div>
  )
}